module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7e8ON"))).then(() => module.bundle.root('hEqeo'));